module.exports = __webpack_public_path__ + "static/media/fatcat_cover.be6f71fc.png";